import styled from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: var(--bg-overlay);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2100;
  padding: 16px;
`;

export const Panel = styled.div`
  background: var(--bg-card);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  padding: 28px;
  width: 100%;
  max-width: ${props => props.$maxWidth || '560px'};
  max-height: calc(100vh - 32px);
  overflow-y: auto;
  min-width: 0;

  &:focus { outline: none; }

  @media (max-width: 560px) {
    padding: 22px 16px;
  }
`;

export const ModalTitle = styled.h2`
  font-family: var(--font-brand);
  font-size: var(--text-xl);
  letter-spacing: -0.3px;
  margin-bottom: 14px;
  overflow-wrap: anywhere;
`;
